import { render, staticRenderFns } from "./DadosEstruturais.vue?vue&type=template&id=6a7af4ec&"
import script from "./DadosEstruturais.vue?vue&type=script&lang=js&"
export * from "./DadosEstruturais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports